module.exports = __webpack_public_path__ + "static/media/container1.bdd964d1.jpg";